import { render, staticRenderFns } from "./AltiumSchematicPart.vue?vue&type=template&id=1c6177dc&scoped=true&"
import script from "./AltiumSchematicPart.vue?vue&type=script&lang=ts&"
export * from "./AltiumSchematicPart.vue?vue&type=script&lang=ts&"
import style0 from "./AltiumSchematicPart.vue?vue&type=style&index=0&id=1c6177dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6177dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VContainer,VSkeletonLoader})
